import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Collapse from '@material-ui/core/Collapse';
import FaceIcon from '@material-ui/icons/Face';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import ViewModule from '@material-ui/icons/ViewModule';
import SwapHoriz from '@material-ui/icons/SwapHoriz';
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import ListItemText from '@material-ui/core/ListItemText';
import {CapitalizeFirstLetter} from '../../util/StringUtil';
import Tooltip from '@material-ui/core/Tooltip';
import Drawer from '@material-ui/core/Drawer';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import axios from 'axios';
import config from '../../config/config';

import IconButton from '@material-ui/core/IconButton';
import vendor from '@material-ui/icons/Face';
import dashboard from '@material-ui/icons/Assessment';
import receipt from '@material-ui/icons/Receipt';
import notification_important from '@material-ui/icons/NotificationImportant';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

import {styles, menuPadding} from '../CSS/MenuStyles';
//import {font, menuPadding} from '../CSS/General-CSS';


class MenuItem extends React.Component{
  constructor(props)
  {
    super(props);
    this.state = {
        open: false,
    }
  }

  getChildren = (id) =>{
    if (this.props.raw && this.props.node.id)
    {
      return this.props.raw.filter(node=> node.parent_id == id)
    }
  }

  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
    this.props.handleIconClick();
  };

  render(){
    const {node,children,raw, handleRoute, parentCollapse, classes, handleIconClick, shouldOpen} = this.props;
    // console.log(this.props.node.id)
    // console.log(this.props.children)
    let dashboard=(
      <div style={{marginLeft:"10px", marginRight:"20px"}}>
        <i class="material-icons" style={{fontSize:"35px"}}>
          assessment
        </i>
      </div>
    )
    let transaction=(
      <div style={{marginLeft:"10px", marginRight:"20px"}}>
        <i class="material-icons" style={{fontSize:"35px"}}>
          receipt
        </i>
      </div>
    )
    let routine=(
      <div style={{marginLeft:"10px", marginRight:"20px"}}>
        <i class="material-icons" style={{fontSize:"35px"}}>
          notification_important
        </i>
      </div>
    )
    let entity=(
      <div style={{marginLeft:"10px", marginRight:"20px"}}>
        <i class="material-icons" style={{fontSize:"35px"}}>
          face
        </i>
      </div>
    )
    let iconList={
       "Dashboard"   : dashboard
      ,"Transaction" : transaction
      ,"Routine"     : routine
      ,"Entity"      : entity
    }


    let childnodes = null;
    let handleClicking = handleRoute.bind(this, node.name);
    if (shouldOpen==false) {
        this.state.open = false;
    }
    let shouldCollapse = parentCollapse && this.state.open; // && shouldOpen
    let expandArrow = null;

    if (children && children.length > 0)
    {
        expandArrow = (this.state && this.state.open)? <ExpandLess /> : <ExpandMore />;

        handleClicking = this.handleClick;
        childnodes = children.map((childnode) =>
        {
        //   console.log("in child")
        let childs = raw.filter(node=> node.parent_id == childnode.id);
        //   console.log(childs)
        return (
            <MenuItem node={childnode} children={childs} raw={raw} handleRoute={handleRoute} parentCollapse={shouldCollapse} handleIconClick={handleIconClick}></MenuItem>
        )
        })
    }

    let childMenu = childnodes ? (
        <Collapse in={shouldCollapse} timeout="auto">
            <List>{childnodes}</List>
        </Collapse>
    ): null

    var item = null;
    if (node.parent_id)
    {
        // leaf
        item = (
        // <Collapse in={shouldCollapse} timeout="auto" unmountOnExit>       
            <Tooltip title={CapitalizeFirstLetter(node.name)}>
                <ListItem style={menuPadding(node.depth)} button onClick={handleClicking}>
                    {/* <ListItemText primary = {CapitalizeFirstLetter(node.name)}/> */}
                    <span style={{
                        overflowX:'hidden', 
                        whiteSpace: 'nowrap', 
                        textOverflow: 'ellipsis',
                        fontSize: '14px',
                    }}>{CapitalizeFirstLetter(node.name)}</span>
                    {expandArrow}
                </ListItem>
            </Tooltip>
        // </Collapse>
        );
    } else{
        // top-level item
        item = (
          <Tooltip title={CapitalizeFirstLetter(node.name)}>
              <ListItem button onClick={handleClicking}>
                  {iconList[CapitalizeFirstLetter(node.name)]}
                  <span className={classes.menuTopLevel} >{CapitalizeFirstLetter(node.name)}</span>
                  {/*{expandArrow}*/}
              </ListItem>
          </Tooltip>
        );
    }

    return (
    <div>
        {item}
        {childMenu}
    </div>
    )
  }
}

MenuItem.propTypes = {
    classes: PropTypes.object.isRequired,
};

MenuItem = withStyles(styles)(MenuItem);



class SideMenuList extends React.Component {

    state = {
        open: false,
        menuList: "",
        menuBEData: ""
    };

    

    componentDidMount(){

        fetch(config.menu).then(response => response.json()).then(res => {
            // console.log("gotten menu");
            // console.log(res);
        	this.setState({menuBEData : res.results})
        }).catch(error => {
			// console.log(error.message);
			// console.log("error");
        });
    }

    handleClick = () => {
        this.setState(state => ({ open: !state.open }));
    };


    render() {
        const { classes} = this.props;
        // let menuViewList=[];
        // console.log(this.state.menuBEData)
        // console.log(this.state.menuList)
        let menuData = this.state.menuBEData
        // let menulist = this.menuViewJSXCreate(this.state.menuList, menuViewList, 0);

        let nodes = null;



        if (this.state && this.state.menuBEData){
          let root = menuData.filter(node=>!node.hasOwnProperty("parent_id"))           

          nodes = root.map((node) => {
            // console.log(node.id)
            let children = menuData.filter(child=>
              // console.log("in child")
              // console.log(child);
              // console.log(child.parent_id)
              child.parent_id == node.id)
            // console.log(children)
            return (
                    <MenuItem node={node} children={children} raw={menuData} handleRoute={this.props.handleRoute} parentCollapse={true} handleIconClick={this.props.handleIconClick} shouldOpen={this.props.shouldOpen}/>
            );
          })
        }
        

        return (
            <div className={classes.rootMenu}>
                    <List
                        component =  "nav"
                    >
                        {nodes}
                    </List>   
            </div>
        );
    }
}

SideMenuList.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SideMenuList);


// WEBPACK FOOTER //
// ./src/components/SharedComponents/SideMenuList_try.js